<style lang="scss" scoped>

</style>

<template>
    <div class="about">
        Regist.vue
    </div>
</template>

<script>

    export default {
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>
